import React from 'react';
import { useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import AppointmentForm from '@/components/forms/AppointmentForm';
import BilingualForm from '@/components/BilingualForm';

const AppointmentModal = ({ isOpen, onClose }) => {
  const { pathname } = useLocation();
  const isEs = pathname === '/es' || pathname.startsWith('/es/');

  if (!isOpen) return null;

  const title    = isEs ? 'Reservar una Cita' : 'Book an Appointment';
  const subtitle = isEs ? 'Programa tu visita a Fort Worth Dental' : 'Schedule your visit to Fort Worth Dental';
  const ariaClose = isEs ? 'Cerrar' : 'Close modal';

  return (
    <div className="fixed inset-0 z-[100] overflow-y-auto">
      <div
        className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      />
      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="relative w-full max-w-2xl bg-white rounded-xl shadow-2xl transform transition-all"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-teal-600 rounded-t-xl">
            <div>
              <h2 className="text-xl font-bold text-white">{title}</h2>
              <p className="text-teal-100 text-sm mt-0.5">{subtitle}</p>
            </div>
            <button
              onClick={onClose}
              className="p-2 text-white hover:bg-teal-700 rounded-full transition-colors"
              aria-label={ariaClose}
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          <div className="p-6 max-h-[70vh] overflow-y-auto">
            {isEs
              ? <BilingualForm lang="es" source="modal_booking_es" />
              : <AppointmentForm source="modal_booking" />}
          </div>

          <div className="px-6 py-4 bg-gray-50 rounded-b-xl border-t border-gray-200">
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-600">
              <span className="flex items-center">
                <span className="mr-1">📞</span>
                <a href="tel:8179853337" className="hover:text-teal-600 font-medium">(817) 985-3337</a>
              </span>
              <span className="hidden sm:inline text-gray-300">|</span>
              <span className="flex items-center">
                <span className="mr-1">📍</span>
                <span>4620 Citylake Blvd W, Fort Worth, TX</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentModal;
